import axios from '../requester';
import _ from 'lodash';
import { DASHBOARD_INTERNAL_TYPES } from 'common/constants/constants';
import { API } from '../constants/api-urls';
import { isMedianMetric } from 'views/root/views/home/views/performance/views/CustomReport/custom-report.util';

export const getMetricsV3 = async (options, axiosOptions = {}) =>
  axios.post(API.METRICS_SEARCH_PATH_V3, options, axiosOptions).catch(() => []);
export const exportMetricsV3 = async (options, axiosOptions = {}) =>
  axios.post(`${API.METRICS_SEARCH_PATH_V3}/export`, options, axiosOptions);
export const getMetricsV3WithTotals = async (options, axiosOptions = {}) =>
  axios.post(API.METRICS_SEARCH_PATH_V3_WITH_TOTALS, options, axiosOptions);

export const getTeamMetricsV3 = async ({
  teamId,
  time_ranges,
  requested_metrics,
  team_git_scope_disabled
}) =>
  getMetricsV3({
    requested_metrics,
    limit: 1,
    offset: 0,
    roll_up: 'custom',
    group_by: 'team',
    time_ranges,
    team_ids: [teamId],
    team_git_scope_disabled
  }).catch(() => []);

export const getDashboardMetricsV3 = async ({
  time_ranges,
  requested_metrics,
  teamId = null,
  roll_up = 'custom',
  ...rest
}) => {
  const options = {
    requested_metrics,
    ...(teamId ? { team_ids: Array.isArray(teamId) ? teamId : [teamId] } : {}),
    group_by: teamId ? 'team' : 'organization',
    time_ranges,
    roll_up,
    ...rest
  };
  return getMetricsV3({
    ...options
  });
};

export const getTeamGoalsDashboard = async selectedTeamId => {
  const dashboardsResult = await getDashboards(selectedTeamId);

  const teamDashboard = _.find(
    _.get(dashboardsResult, 'items', []),
    ({ internal_type }) => internal_type === DASHBOARD_INTERNAL_TYPES.TEAM_GOALS
  );

  const { id: teamDashboardId, definition = {} } = teamDashboard || {};
  const { widgets } = definition;

  return { teamDashboardId, widgets };
};

export const getAvailableMetrics = async () =>
  axios.get(`${API.DASHBOARDS}/widgets`);

export const getDashboards = async teamId =>
  axios.get(teamId ? `${API.DASHBOARDS}?team_id=${teamId}` : API.DASHBOARDS);

export const getDashboardsExcludeTeamGoals = async () =>
  axios.get(`${API.DASHBOARDS}?exclude_team_goals=true`);

export const createDashboard = async newDashboard =>
  axios.post(API.DASHBOARDS, newDashboard);

export const updateDashboard = async newDashboard =>
  axios.put(`${API.DASHBOARDS}/${newDashboard.id}`, newDashboard);

export const deleteDashboard = async dasboardId =>
  axios.delete(`${API.DASHBOARDS}/${dasboardId}`);

export const toggleDashboardWidget = async (dasboardId, action, widgetId) =>
  axios.put(`${API.DASHBOARDS}/${dasboardId}/toggle_widget`, {
    action,
    widgetId
  });

export const convertMetricsNameToV3 = (metrics, settingValue) => {
  const result = metrics.map(name => ({
    name,
    ...(isMedianMetric(name) && settingValue ? { agg: settingValue } : {})
  }));
  return result;
};

export const getMappedV3Data = ({ v3DataResult }) => {
  const mappedV3Data = Object.keys(v3DataResult).reduce((acc, curr) => {
    acc[curr.split(':')[0]] = v3DataResult[curr];
    return acc;
  }, {});

  return mappedV3Data;
};
